//Need this for webpack to copy index.html file into dist folder after npm run build

// Todo: Figure out how to get script src=./dist/build.js in index.html to chance to src=build.js when running npm run build
require("file-loader?name=[name].[ext]!../public/index.html");

import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import UploadButton from "vuetify-upload-button";
import VueMarkdown from "vue-markdown";
import VueFileAgent from "vue-file-agent";
import VueApexCharts from "vue-apexcharts";

import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import { router } from "./router";
import { store } from "./store";
import vuetify from "./plugins/vuetify";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.use(VueFileAgent);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(UploadButton);
Vue.use(VueMarkdown);
Vue.component("apexchart", VueApexCharts);

Sentry.init({
  Vue,
  dsn: "https://e515d7a0ad704318a6bca2c2fc4983ea@o141124.ingest.sentry.io/5552198",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", process.env.VUE_APP_API_URL, /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  sampleRate:0.1,
  // release:
  environment: process.env.NODE_ENV
});

export const eventBus = new Vue();

new Vue({
  render: h => h(App),
  store,
  router,
  vuetify
}).$mount("#app");
